export default __webpack_public_path__ + "fonts/icomoon.eot?44eccfdf7db060399d01355a33c5ef1f";